'use strict';

angular.module('directives.iamEvent')

.controller('iamEventAndTaskController', ['$scope', '$state', 'eventService', function ($scope, $state, eventService) {

    $scope.ctrlCtxt = {};

    // Show Created By?
    $scope.showCreatedBy = function () {
        if (!$scope.boxContext || !$scope.boxContext.ForHistory) return false;
        if (!$scope.model.CreatedBy) return false;

        return $scope.model.CreatedBy !== 'Workflow';
    }

    // Toggle Show Error Msg Stack
    $scope.toggleShowErrorMsgStack = function ($event) {
        $event.stopPropagation();

        $scope.ctrlCtxt.showErrorMsgStack = !$scope.ctrlCtxt.showErrorMsgStack;
    };

    // Show Resubmit Event Action?
    $scope.showResubmitEventAction = function () {
        if (!$scope.boxContext) return;
        if (!$scope.boxContext.ShowDetails) return false;

        return $scope.model.CanBeResubmitted;
    };

    // Show Ignore Event Action?
    $scope.showIgnoreEventAction = function () {
        if (!$scope.boxContext) return;
        if (!$scope.boxContext.ShowDetails) return false;
        if (!$scope.boxContext.AuthenticatedUser) return;
        if (!$scope.boxContext.AuthenticatedUser.IsInAdministrationGroup) return false;

        return $scope.model.CanBeIgnored;
    };

    // Is Need Retry?
    $scope.isNeedRetry = function () {
        return $scope.model.TaskStateStatusId === 6;
    };

    // Resubmit Event
    $scope.resubmitEvent = function ($event) {
        $event && $event.stopPropagation();
        if ($scope.ctrlCtxt.areActionsDisabled) return;

        $scope.ctrlCtxt.areActionsDisabled = true;

        eventService
            .resubmitEvent($scope.model.EventID)
            .then(function (event) {
                $scope.refreshEvent($event);
            });
    };


    // Confirm Event
    $scope.confirmEvent = function ($event) {
        $event && $event.stopPropagation();
        if ($scope.ctrlCtxt.areActionsDisabled) return;

        $scope.ctrlCtxt.areActionsDisabled = true;

        eventService
            .confirmEvent($scope.model.EventID)
            .then(function (event) {
                $scope.refreshEvent($event);
            });
    };

    // Reject Event
    $scope.rejectEvent = function ($event) {
        $event && $event.stopPropagation();
        if ($scope.ctrlCtxt.areActionsDisabled) return;

        $scope.ctrlCtxt.areActionsDisabled = true;

        eventService
            .rejectEvent($scope.model.EventID)
            .then(function (event) {
                $scope.refreshEvent($event);
            });
    };

    // Ignore Event
    $scope.ignoreEvent = function ($event) {
        $event && $event.stopPropagation();
        if ($scope.ctrlCtxt.areActionsDisabled) return;

        $scope.ctrlCtxt.areActionsDisabled = true;

        eventService.ignoreEvent($scope.model.EventID)
            .then(function (event) {
                $scope.refreshEvent($event);
            });
    };

    // Continue Process After Pending Event
    $scope.continueProcessAfterPendingEvent = function ($event) {
        $event && $event.stopPropagation();
        if ($scope.ctrlCtxt.areActionsDisabled) return;

        $scope.ctrlCtxt.areActionsDisabled = true;

        eventService
            .continueProcessAfterPendingEvent($scope.model.EventID)
            .then(function (event) {
                $scope.refreshEvent($event);
            });
    };

    // Continue Process After Ignoring Pending Event
    $scope.continueProcessAfterIgnoringPendingEvent = function ($event) {
        $event && $event.stopPropagation();
        if ($scope.ctrlCtxt.areActionsDisabled) return;

        $scope.ctrlCtxt.areActionsDisabled = true;

        eventService
            .continueProcessAfterIgnoringPendingEvent($scope.model.EventID)
            .then(function (event) {
                $scope.refreshEvent($event);
            });
    };

    // Refresh Event
    $scope.refreshEvent = function ($event) {
        $event && $event.stopPropagation();
        var currentEventId = $scope.model.EventID;

        $scope.ctrlCtxt.hasBeenRefreshed = false;

        $scope
            .updateEventGroup()($scope.model)
            .then(function (updatedEventGroup) {
                if (updatedEventGroup.EventID === currentEventId) {
                    $scope.ctrlCtxt.hasBeenRefreshed = true;
                    $scope.ctrlCtxt.areActionsDisabled = false;
                }
            });
    };

    // Hide Task State Title?
    $scope.hideTaskStateTitle = function () {
        return $scope.model.HideTaskStateTitle;
    };

    // Get Status Context Template Url
    $scope.getStatusContextTemplateUrl = function () {
        if (!$scope.boxContext) return;
        if (!$scope.boxContext.EventDetails) return;
        if (!$scope.boxContext.EventDetails.WorkflowStatusContext) return;
        if (!$scope.boxContext.EventDetails.WorkflowStatusContext.TemplateName) return;

        return '/app/shared/components/directives/iamEventDirective-default_' +
                    $scope.boxContext.EventDetails.WorkflowStatusContext.TemplateName + '.tpl.html';
    };

}]);